import moment from 'moment';

import {
  ControlTypeEnum,
  DictionariesEnum,
  FieldsEnum,
  FormSectionHeadingType,
  LabelEnum,
  MessagesEnum,
  ScreenEnum,
  SectionsEnum,
  TooltipsEnum,
  MessageTypeEnum,
  QuestionMessagesEnum,
  ControlLabelEnum,
  ValidationErrorMessagesEnum,
  ModelPathEnum,
} from 'app/shared/enums';

export const mubiLeasingFormConfig = {
  screens: [
    {
      key: ScreenEnum.MubiLeasingShortPath,
      sections: [
        {
          key: SectionsEnum.ShortCalculationPath,
          label: '',
          subLabel: '',
          visible: true,
          questions: [
            {
              key: FieldsEnum.CarRegistrationNumber,
              modelPath: FieldsEnum.CarRegistrationNumber,
              label: ControlLabelEnum.CarRegistrationNumberLabel,
              subLabel: '',
              type: ControlTypeEnum.EurobandCarRegistrationNumber,
              required: false,
              visible: true,
              editable: true,
              groupName: 'registrationNumber',
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              onChange: ['carRegistrationNumberChange'],
            },
            {
              key: FieldsEnum.CarRegistrationNumberNotKnown,
              modelPath: FieldsEnum.CarRegistrationNumberNotKnown,
              label: ControlLabelEnum.CarRegistrationNumberNotKnownLabel,
              tooltip: '',
              subLabel: '',
              type: ControlTypeEnum.GroupedCheckbox,
              onChange: ['registrationNumberNotKnownChange'],
              messages: [
                {
                  key: MessagesEnum.CarRegistrationNumberInvalid,
                  type: MessageTypeEnum.Danger,
                  content: LabelEnum.InvalidCarRegistrationNumber,
                  visible: false,
                },
                {
                  key: MessagesEnum.CarRegistrationNumberRequired,
                  type: MessageTypeEnum.Danger,
                  content: LabelEnum.FieldRequired,
                  visible: false,
                },
                {
                  key: MessagesEnum.QuotationRegistrationNumberObfuscated,
                  type: MessageTypeEnum.Warning,
                  content: QuestionMessagesEnum.FieldObfuscatedMessage,
                  visible: false,
                },
                {
                  key: MessagesEnum.RegistrationNumberNotKnown,
                  type: MessageTypeEnum.Warning,
                  content:
                    QuestionMessagesEnum.RegistrationNumberNotKnownWarningMessage,
                  visible: false,
                },
              ],
              required: false,
              visible: true,
              editable: true,
              groupName: 'registrationNumber',
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
            },
            {
              key: FieldsEnum.OwnerBirthDate,
              modelPath: 'mainOwner.birthDate',
              label: ControlLabelEnum.OwnerBirthDateLabel,
              subLabel: '',
              type: ControlTypeEnum.Date,
              required: true,
              visible: true,
              editable: true,
              minDate: moment(new Date())
                .subtract(100, 'year')
                .format('YYYY-MM-DD'),
              maxDate: moment(new Date())
                .subtract(13, 'year')
                .format('YYYY-MM-DD'),
              startDate: moment(new Date())
                .subtract(30, 'year')
                .format('YYYY-MM-DD'),
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              datePickerViewType: 'century',
              onChange: ['mainOwnerBirthDateChanged'],
            },
            {
              key: FieldsEnum.ConsentRegulations,
              modelPath: ModelPathEnum.ConsentsRegulationsConsent,
              label: '',
              type: ControlTypeEnum.Checkbox,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              width: 'full',
              onChange: ['requiredCalculationConsentChange'],
            },
            {
              key: FieldsEnum.ConsentCepik,
              modelPath: ModelPathEnum.ConsentsCepikConsent,
              label: '',
              type: ControlTypeEnum.Checkbox,
              onChange: ['onCepikConsentChange'],
              required: false,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: true,
              width: 'full',
            },
            {
              key: FieldsEnum.ConsentMarketing,
              modelPath: ModelPathEnum.ConsentsMarketingConsent,
              label: '',
              type: ControlTypeEnum.Checkbox,
              onChange: ['onInsuranceMarketingConsentChange'],
              required: false,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              width: 'full',
            },
          ],
        },
      ],
    },
    {
      key: ScreenEnum.MubiLeasingScreen1,
      sections: [
        {
          key: SectionsEnum.MubiLeasingSectionInsurance,
          label: LabelEnum.YourInsurance,
          subLabel: '',
          headingStyle: FormSectionHeadingType.Compact,
          visible: true,
          questions: [
            {
              key: FieldsEnum.VehicleType,
              modelPath: FieldsEnum.VehicleType,
              type: ControlTypeEnum.VehicleType,
              label: LabelEnum.Vehicle,
              answersDictionaryKey: DictionariesEnum.VehicleType,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: false,
              onChange: ['setupAutocascoAvailability'],
            },
            {
              key: FieldsEnum.InsuranceScope,
              modelPath: 'scope.components',
              type: ControlTypeEnum.CheckboxGroup,
              label: ControlLabelEnum.InsuranceScopeLabel,
              answersDictionaryKey: DictionariesEnum.CarInsuranceScopes,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              disabledDictionaryEntries: ['OC'],
              tooltip: TooltipsEnum.InsuranceScope,
              width: 'xl',
            },
            {
              key: FieldsEnum.LegalStatusLeased,
              modelPath: FieldsEnum.LegalStatusLeased,
              type: ControlTypeEnum.Radio,
              label: ControlLabelEnum.LegalStatusLeasedLabel,
              answersDictionaryKey: DictionariesEnum.LegalStatus,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              onChange: ['onLeasedStatusChange'],
              messages: [
                {
                  key: MessagesEnum.LeasedCarInfo,
                  type: MessageTypeEnum.Warning,
                  content: QuestionMessagesEnum.LeasedCarInfo,
                  visible: false,
                },
              ],
              width: 'md',
            },
            {
              key: FieldsEnum.leasingType,
              modelPath: FieldsEnum.leasingType,
              type: ControlTypeEnum.Radio,
              label: ControlLabelEnum.LeasedTypeLabel,
              answersDictionaryKey: DictionariesEnum.LeasingTypes,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              onChange: ['onLeasedTypeChange'],
              tooltip: TooltipsEnum.LeasedType,
              width: 'md',
            },
          ],
        },
        {
          key: SectionsEnum.MubiLeasingSectionCar1,
          label: LabelEnum.VehicleDetails,
          subLabel: '',
          visible: true,
          questions: [
            {
              key: FieldsEnum.CarLeasingVehicleType,
              modelPath: FieldsEnum.CarLeasingVehicleType,
              label: ControlLabelEnum.CarTypeLabel,
              type: ControlTypeEnum.Radio,
              answersDictionaryKey: DictionariesEnum.LeasingVehicleTypes,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              onChange: ['onLeasingVehicleTypeChange'],
              messages: [
                {
                  key: MessagesEnum.NoInsuranceForThisVehicleType,
                  type: MessageTypeEnum.Danger,
                  content:
                    ValidationErrorMessagesEnum.NoInsuranceForThisVehicleType,
                  visible: false,
                },
              ],
              width: 'full',
            },
            {
              key: FieldsEnum.CarProductionYear,
              modelPath: FieldsEnum.CarProductionYear,
              label: LabelEnum.SelectProductionYear,
              type: ControlTypeEnum.DateList,
              answersDictionaryKey: DictionariesEnum.CarProductionYears,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              onChange: [
                'setupAutocascoAvailability',
                'onProductionYearChange',
              ],
              messages: [],
            },
            {
              key: FieldsEnum.CarMake,
              modelPath: FieldsEnum.CarMake,
              label: LabelEnum.Make,
              type: ControlTypeEnum.List,
              answersDictionaryKey: DictionariesEnum.CarMakes,
              answerGroups: [
                {
                  key: 'car.make.popular',
                  groupName: 'popular',
                  label: LabelEnum.PopularMakes,
                  subLabel: '',
                },
                {
                  key: 'car.make.all',
                  groupName: 'all',
                  label: LabelEnum.AllMakes,
                  subLabel: '',
                },
              ],
              answersDictionaryParams: [FieldsEnum.CarProductionYear],
              dependsOn: [FieldsEnum.CarProductionYear],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              width: 'md',
            },
            {
              key: FieldsEnum.CarModel,
              modelPath: FieldsEnum.CarModel,
              label: ControlLabelEnum.Model,
              type: ControlTypeEnum.List,
              answersDictionaryKey: DictionariesEnum.CarModels,
              answersDictionaryParams: [
                FieldsEnum.CarProductionYear,
                FieldsEnum.CarMake,
              ],
              dependsOn: [FieldsEnum.CarMake],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              width: 'md',
            },
            {
              key: FieldsEnum.CarFuelType,
              modelPath: FieldsEnum.CarFuelType,
              label: LabelEnum.FuelType,
              type: ControlTypeEnum.List,
              answersDictionaryKey: DictionariesEnum.CarFuelTypes,
              answersDictionaryParams: [
                FieldsEnum.CarProductionYear,
                FieldsEnum.CarModel,
              ],
              dependsOn: [FieldsEnum.CarModel],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              width: 'md',
            },
            {
              key: FieldsEnum.CarEngineCapacity,
              modelPath: 'car.engineVolume',
              label: LabelEnum.EngineCapacity,
              type: ControlTypeEnum.List,
              answersDictionaryKey: DictionariesEnum.EngineCapacities,
              answersDictionaryParams: [
                FieldsEnum.CarProductionYear,
                FieldsEnum.CarModel,
                FieldsEnum.CarFuelType,
              ],
              dependsOn: [FieldsEnum.CarFuelType],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              width: 'md',
            },
            {
              key: FieldsEnum.CarDoorsCount,
              modelPath: FieldsEnum.CarDoorsCount,
              label: LabelEnum.DoorsCount,
              type: ControlTypeEnum.List,
              answersDictionaryKey: DictionariesEnum.CarDoors,
              answersDictionaryParams: [
                FieldsEnum.CarProductionYear,
                FieldsEnum.CarModel,
                FieldsEnum.CarFuelType,
                FieldsEnum.CarEngineCapacity,
              ],
              dependsOn: [FieldsEnum.CarEngineCapacity],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              width: 'md',
            },
            {
              key: FieldsEnum.CarHorsePower,
              label: LabelEnum.CarHorsePower,
              answersDictionaryKey: DictionariesEnum.CarModelVersions,
              answersDictionaryParams: [
                FieldsEnum.CarProductionYear,
                FieldsEnum.CarModel,
                FieldsEnum.CarFuelType,
                FieldsEnum.CarEngineCapacity,
                FieldsEnum.CarDoorsCount,
              ],
              dependsOn: [FieldsEnum.CarDoorsCount],
              type: ControlTypeEnum.List,
              modelPath: '',
              visible: true,
              required: false,
              shouldPatch: false,
              width: 'full',
            },
            {
              key: FieldsEnum.CarVersionEt,
              modelPath: FieldsEnum.CarVersionEt,
              label: ControlLabelEnum.CarVersionLabel,
              type: ControlTypeEnum.List,
              answersDictionaryKey: DictionariesEnum.CarModelVersions,
              answersDictionaryParams: [
                FieldsEnum.CarProductionYear,
                FieldsEnum.CarModel,
                FieldsEnum.CarFuelType,
                FieldsEnum.CarEngineCapacity,
                FieldsEnum.CarDoorsCount,
              ],
              dependsOn: [FieldsEnum.CarDoorsCount],
              onChange: ['onVersionEtChange'],
              messages: [
                {
                  key: MessagesEnum.NoVersionEtWarning,
                  type: MessageTypeEnum.Warning,
                  content: QuestionMessagesEnum.NoVersionEtWarning,
                  visible: false,
                },
              ],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              width: 'xl',
            },
            {
              key: FieldsEnum.CarModelIe,
              modelPath: FieldsEnum.CarModelIe,
              label: ControlLabelEnum.ModelIe,
              type: ControlTypeEnum.List,
              answersDictionaryKey: DictionariesEnum.InfoekspertModels,
              answersDictionaryParams: [
                FieldsEnum.CarProductionYear,
                FieldsEnum.CarMake,
                FieldsEnum.CarEngineCapacity,
                FieldsEnum.CarFuelType,
                FieldsEnum.CarDoorsCount,
                FieldsEnum.CarVersionEt,
              ],
              dependsOn: [FieldsEnum.CarVersionEt],
              onChange: ['onModelIeChange'],
              messages: [
                {
                  key: MessagesEnum.NoModelIeWarning,
                  type: MessageTypeEnum.Warning,
                  content: QuestionMessagesEnum.NoModelIeWarning,
                  visible: false,
                },
                {
                  key: MessagesEnum.NoModelAndVersionError,
                  type: MessageTypeEnum.Danger,
                  content: QuestionMessagesEnum.NoModelAndVersionError,
                  visible: false,
                },
              ],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              width: 'xl',
            },
            {
              key: FieldsEnum.CarVersionIe,
              modelPath: FieldsEnum.CarVersionIe,
              label: ControlLabelEnum.CarVersionIeLabel,
              type: ControlTypeEnum.List,
              answersDictionaryKey: DictionariesEnum.InfoekspertModelVersions,
              answersDictionaryParams: [
                FieldsEnum.CarProductionYear,
                FieldsEnum.CarMake,
                FieldsEnum.CarEngineCapacity,
                FieldsEnum.CarFuelType,
                FieldsEnum.CarDoorsCount,
                FieldsEnum.CarVersionEt,
                FieldsEnum.CarModelIe,
              ],
              dependsOn: [FieldsEnum.CarModelIe],
              onChange: ['onVersionIeChange'],
              messages: [
                {
                  key: MessagesEnum.NoVersionIeWarning,
                  type: MessageTypeEnum.Warning,
                  content: QuestionMessagesEnum.NoModelIeWarning,
                  visible: false,
                },
                {
                  key: MessagesEnum.NoVersionIeAndEtError,
                  type: MessageTypeEnum.Danger,
                  content: QuestionMessagesEnum.NoVersionIeAndEtError,
                  visible: false,
                },
              ],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              width: 'xl',
            },
            {
              key: FieldsEnum.InsuranceStartDate,
              modelPath: 'startDate',
              label: ControlLabelEnum.InsuranceStartDateLabel,
              type: ControlTypeEnum.Date,
              onChange: ['onInsuranceStartDateChange'],
              messages: [
                {
                  key: MessagesEnum.InsurancePastDateNotAllowed,
                  type: MessageTypeEnum.Danger,
                  content:
                    QuestionMessagesEnum.InsurancePastDateNotAllowedError,
                  visible: false,
                },
              ],
              required: true,
              visible: true,
              editable: true,
              minDate: moment(new Date()).format('YYYY-MM-DD'),
              maxDate: moment(new Date()).add(1, 'year').format('YYYY-MM-DD'),
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              datePickerViewType: 'month',
            },
          ],
        },
      ],
    },
    {
      key: ScreenEnum.MubiLeasingScreen2,
      sections: [
        {
          key: SectionsEnum.MubiLeasingSectionCar2,
          label: ControlLabelEnum.CarUsageLabel,
          subLabel: '',
          visible: true,
          questions: [
            {
              key: FieldsEnum.CarMileage,
              modelPath: FieldsEnum.CarMileage,
              label: ControlLabelEnum.CarMileageLabel,
              tooltip: '',
              subLabel: '',
              type: ControlTypeEnum.Mileage,
              required: true,
              visible: true,
              editable: true,
              inlineTooltip: ControlLabelEnum.CarMileageInlineTooltip,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
            },
            {
              key: FieldsEnum.PlannedUsageYearlyMileage,
              modelPath: FieldsEnum.PlannedUsageYearlyMileage,
              label: ControlLabelEnum.PlannedUsageYearlyMileageLabel,
              tooltip: TooltipsEnum.PlannedUsageYearlyMileageTooltip,
              type: ControlTypeEnum.List,
              answersDictionaryKey: DictionariesEnum.CarPlannedYearlyMileages,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: true,
            },
            {
              key: FieldsEnum.CarFirstRegistrationDate,
              modelPath: FieldsEnum.CarFirstRegistrationDate,
              label: ControlLabelEnum.FirstRegistrationDateLabel,
              subLabel: '',
              type: ControlTypeEnum.Date,
              required: true,
              visible: true,
              editable: true,
              maxDate: moment(new Date()).format('YYYY-MM-DD'),
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: true,
              datePickerViewType: 'decade',
              dependsOn: [FieldsEnum.CarProductionYear],
              onChange: ['onFirstRegistrationDateChange'],
              messages: [
                {
                  key: MessagesEnum.FirstRegistrationDateCantBeInFuture,
                  type: MessageTypeEnum.Danger,
                  content:
                    ValidationErrorMessagesEnum.FirstRegistrationDateCantBeInFuture,
                  visible: false,
                },
                {
                  key: MessagesEnum.FirstRegistrationDateCantBeBeforeProdYear,
                  type: MessageTypeEnum.Danger,
                  content:
                    ValidationErrorMessagesEnum.FirstRegistrationDateCantBeBeforeProdYear,
                  visible: false,
                },
                {
                  key: MessagesEnum.FirstRegistrationDateCantBeToLate,
                  type: MessageTypeEnum.Danger,
                  content:
                    ValidationErrorMessagesEnum.FirstRegistrationDateCantBeToLate,
                  visible: false,
                },
              ],
            },
            {
              key: FieldsEnum.CarOwnerPurchaseYear,
              modelPath: FieldsEnum.CarOwnerPurchaseYear,
              label: ControlLabelEnum.CarOwnerPurchaseYearLabel,
              tooltip: TooltipsEnum.CarOwnerPurchaseYearTooltip,
              subLabel: '',
              type: ControlTypeEnum.DateList,
              answersDictionaryKey: DictionariesEnum.CarPurchaseYears,
              answersDictionaryParams: [
                'firstRegistrationDate:car.firstRegistrationDate',
              ],
              dependsOn: ['car.firstRegistrationDate'],
              onChange: [],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: true,
            },
            {
              key: FieldsEnum.CarPreviousInsurer,
              modelPath: FieldsEnum.CarPreviousInsurer,
              label: ControlLabelEnum.CarPreviousInsurerLabel,
              tooltip: TooltipsEnum.CarPreviousInsurer,
              type: ControlTypeEnum.List,
              answersDictionaryKey: DictionariesEnum.CarInsurers,
              onChange: [],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: true,
            },
            {
              key: FieldsEnum.CarVin,
              modelPath: FieldsEnum.CarVin,
              type: ControlTypeEnum.CarVin,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              label: ControlLabelEnum.CarVinLabel,
              subLabel: '',
              tooltip: TooltipsEnum.CarVin,
            },
            {
              key: FieldsEnum.CarLeaseCompany,
              modelPath: FieldsEnum.CarLeaseCompany,
              label: ControlLabelEnum.CarLeaseCompanyLabel,
              type: ControlTypeEnum.List,
              answersDictionaryKey: DictionariesEnum.LeasingCompanies,
              onChange: ['onCarLeaseCompanyChange'],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: false,
              clearOnHide: true,
            },
          ],
        },
        {
          key: SectionsEnum.MubiLeasingSectionLeasingCompany,
          label: ControlLabelEnum.LeasingCompanyLabel,
          subLabel: '',
          visible: false,
          questions: [
            {
              key: FieldsEnum.LeasingCompanyName,
              modelPath: FieldsEnum.LeasingCompanyName,
              label: ControlLabelEnum.LeasingCompanyNameLabel,
              type: ControlTypeEnum.Text,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: true,
            },
            {
              key: FieldsEnum.LeasingCompanyNip,
              modelPath: FieldsEnum.LeasingCompanyNip,
              label: ControlLabelEnum.LeasingCompanyNipLabel,
              type: ControlTypeEnum.NipNumber,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: true,
            },
          ],
        },
      ],
    },
    {
      key: ScreenEnum.MubiLeasingScreen3,
      sections: [
        {
          key: SectionsEnum.MubiLeasingSectionLesseeData,
          label: LabelEnum.LesseeData,
          subLabel: '',
          visible: true,
          questions: [
            {
              key: FieldsEnum.OwnerName,
              modelPath: ModelPathEnum.MainOwnerName,
              type: ControlTypeEnum.Name,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: true,
              label: LabelEnum.FirstName,
              width: 'md',
            },
            {
              key: FieldsEnum.OwnerLastName,
              modelPath: ModelPathEnum.MainOwnerLastName,
              type: ControlTypeEnum.LastName,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: true,
              label: LabelEnum.LastName,
              width: 'md',
            },
          ],
        },
        {
          key: SectionsEnum.MubiLeasingSectionLesseeData2,
          label: '',
          subLabel: '',
          visible: true,
          questions: [
            {
              key: FieldsEnum.InsurantNip,
              modelPath: FieldsEnum.InsurantNip,
              label: ControlLabelEnum.NipNumberLabel,
              type: ControlTypeEnum.NipNumber,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              tooltip: TooltipsEnum.NipNumber,
              messages: [
                {
                  key: MessagesEnum.InsurantNipNumberObfuscated,
                  type: MessageTypeEnum.Warning,
                  content: QuestionMessagesEnum.FieldObfuscatedMessage,
                  visible: false,
                },
              ],
              onChange: ['showInsurantNipNumberObfuscatedMessage'],
            },
            {
              key: FieldsEnum.InsurantBusinessLegalStructure,
              modelPath: FieldsEnum.InsurantBusinessLegalStructure,
              label: ControlLabelEnum.InsurantBusinessLegalStructureLabel,
              type: ControlTypeEnum.List,
              answersDictionaryKey:
                DictionariesEnum.InsurantBusinessLegalStructure,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              tooltip: TooltipsEnum.InsurantBusinessLegalStructure,
              width: 'full',
              onChange: ['onInsurantBusinessLegalStructureChange'],
            },
            {
              key: FieldsEnum.OwnerPesel,
              modelPath: ModelPathEnum.MainOwnerPeselNumber,
              type: ControlTypeEnum.Pesel,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: true,
              label: ControlLabelEnum.YourPeselLabel,
              subLabel: '',
              tooltip: TooltipsEnum.OwnerPesel,
              helperText: LabelEnum.FieldNotRequired,
            },
            {
              key: FieldsEnum.OwnerHomeAddressZipCode,
              modelPath: 'mainOwner.homeAddress.zipCode',
              label: ControlLabelEnum.ApartmentZipCodeLabel,
              type: ControlTypeEnum.ZipCode,
              subLabel: '',
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: true,
              width: 'md',
              labelAboveInputField: true,
              onChange: ['ownerHomeAddressZipCodeChange'],
            },
            {
              key: FieldsEnum.OwnerHomeAddressCity,
              modelPath: 'mainOwner.homeAddress.city',
              label: ControlLabelEnum.ApartmentCityLabel,
              subLabel: '',
              type: ControlTypeEnum.List,
              answersDictionaryKey: DictionariesEnum.Cities,
              answersDictionaryParams: ['zipCode:owner.homeAddress.zipCode'],
              dependsOn: ['owner.homeAddress.zipCode'],
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: true,
              labelAboveInputField: true,
            },
            {
              key: FieldsEnum.InsurancePhoneNumber,
              modelPath: 'phoneNumber',
              label: LabelEnum.PhoneNumber,
              type: ControlTypeEnum.PhoneNumber,
              required: true,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              messages: [
                {
                  key: MessagesEnum.WeWillContactYouToPresentOffers,
                  type: MessageTypeEnum.BulbInfo,
                  content: LabelEnum.YourDataIsSafe,
                  visible: true,
                },
                {
                  key: MessagesEnum.InsurancePhoneNumberObfuscated,
                  type: MessageTypeEnum.Warning,
                  content: QuestionMessagesEnum.FieldObfuscatedMessage,
                  visible: false,
                },
              ],
              onChange: ['showInsurancePhoneNumberObfuscatedMessage'],
            },
            {
              key: FieldsEnum.InsurantEmail,
              modelPath: 'emailAddress',
              label: LabelEnum.EmailAddress,
              type: ControlTypeEnum.Email,
              required: false,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              helperText: LabelEnum.FieldNotRequired,
              onChange: ['showCalculationInsurantEmailObfuscatedMessage'],
              messages: [
                {
                  key: MessagesEnum.CalculationInsurantEmailObfuscated,
                  type: MessageTypeEnum.Warning,
                  content: QuestionMessagesEnum.FieldObfuscatedMessage,
                  visible: false,
                },
              ],
            },
          ],
        },
        {
          key: SectionsEnum.MubiLeasingSectionConsents,
          label: '',
          subLabel: '',
          visible: true,
          tooltip: TooltipsEnum.MjmConsent,
          questions: [
            {
              key: FieldsEnum.InsuranceMarketingEmailConsent,
              modelPath: ModelPathEnum.ConsentsMarketingConsent,
              label: '',
              type: ControlTypeEnum.Checkbox,
              onChange: ['onInsuranceMarketingConsentChange'],
              required: false,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              width: 'full',
            },
            {
              key: FieldsEnum.ConsentMjm,
              modelPath: ModelPathEnum.ConsentsMjmConsent,
              label: '',
              type: ControlTypeEnum.Checkbox,
              required: false,
              visible: true,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              width: 'full',
            },
            {
              key: FieldsEnum.ConsentMjm2,
              modelPath: ModelPathEnum.ConsentsMjmConsent,
              label: '',
              tooltip: TooltipsEnum.MjmConsent,
              type: ControlTypeEnum.Checkbox,
              required: false,
              visible: false,
              editable: true,
              ignoreAnonymized: true,
              shouldPatch: true,
              clearOnHide: false,
              width: 'full',
            },
          ],
        },
      ],
    },
  ],
};
